import React, { useEffect } from "react";
import styled from "styled-components";
import { validatePhoneNumber } from "../utils";
import countries from "../../../countries.json";
import colors from "../../config/colors";

const RequestMeetingFormWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #efefef;
  border-radius: 0;
  padding: ${props => props.isMeetingRequest ? "9px 8px":"8px"};
  background-color: ${props => props.isMeetingRequest && "transparent"};
  max-width: ${props => props.isMeetingRequest && "600px"}
`;

const CountryCode = styled.div`
  margin-right: 8px;
  padding: 2px;
  border: 1px solid #efefef;
  border-radius: 37px;
  background: #efefef;
  color: #757589;
  width:100%
`;

const SelectStyle = styled.select`
  color: ${props => props.isMeetingRequest && "#302F2F"};
  border: none;
  width: 100%;
  font-size: ${props => props.isMeetingRequest && "16px"};
  font-family: "Nunito Sans";
& option{
  background:'#efefef';

}
`;

const ComboBox = ({
  options,
  placeholder,
  setValue,
  value,
  isMeetingRequest,
}) => {
  return (
    <RequestMeetingFormWrapper isMeetingRequest={isMeetingRequest}>
      <SelectStyle
        value={value}
        placeholder={placeholder}
        name="Select a program"
        onChange={(e) => {
          setValue(e.target.value);
        }}
        isMeetingRequest={isMeetingRequest}
      >
        {options?.map((option) => (
          <option key={option?.id} value={option?.id}>
            {option?.title}
          </option>
        ))}
      </SelectStyle>
    </RequestMeetingFormWrapper>
  );
};

export default ComboBox;
